import { MtUser } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setUserProfileView = (profile: MtUser) => ({
    type: inferLiteral(types.USER_PROFILE_VIEW),
    profile,
})
export const setUserProfileEdit = (profile: MtUser) => ({
    type: inferLiteral(types.USER_PROFILE_EDIT),
    profile,
})
export const setUserProfileReloadView = (value: boolean) => ({
    type: inferLiteral(types.USER_PROFILE_RELOAD_VIEW),
    value,
})
export const setUserProfileReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.USER_PROFILE_RELOAD_EDIT),
    value,
})
